<template>
	<div ref="dom"></div>
</template>

<script>
	import echarts from 'echarts'
	import {
		on,
		off
	} from '@/libs/tools'
	export default {
		name: 'serviceRequests',
		data() {
			return {
				dom: null
			}
		},
		props: ["xAxisData", "series", "name", "end"],
		methods: {
			resize() {
				this.dom.resize()
			}
		},
		mounted() {
			const option = {

				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				dataZoom: { //滚动
					borderColor: "rgba(33, 118, 250, 0.0)",
					show: true,
					realtime: true,
					bottom: '10%',
					height: 20,
					start: 0,
					end: this.end
				},
				grid: {
					top: '3%',
					left: '1.2%',
					right: '1%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [{
					type: 'category',
					boundaryGap: false,
					//data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
					data: this.xAxisData
				}],
				yAxis: [{
					type: 'value'
				}],
				series: this.series
				// [
				//      {
				//        name: '温度',
				//        type: 'line',
				//        stack: '总量',
				//        areaStyle: { normal: {
				//          color: '#2176FA'
				//        } },
				//        data: [120, 132, 101, 134, 90, 230, 210]
				//      }
				//    ]
			}
			this.$nextTick(() => {
				this.dom = echarts.init(this.$refs.dom)
				this.dom.setOption(option)
				on(window, 'resize', this.resize)
			})
		},
		beforeDestroy() {
			off(window, 'resize', this.resize)
		},
		watch: {
		    //观察option的变化
		    option: {
		      handler(newVal, oldVal) {
		        if (this.chart) {
		          if (newVal) {
		            this.chart.setOption(newVal);
		          } else {
		            this.chart.setOption(oldVal);
		          }
		        } else {
		            this.init();
		        }
		      },
		      deep: true //对象内部属性的监听，关键。
		    }
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/alliance/finance/baobiao/example.vue